import { useService } from '@core/inversify-react';
import { GetCurrentCashRegisterBalanceRepoType, IGetCurrentCashRegisterBalanceRepo } from '../repos';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICashRegister } from '../interfaces';

export const useCacheRegisterBalance = (options?: UseQueryOptions<ICashRegister, Error, ICashRegister, string[]>) => {
  const getCurrentCashRegisterBalanceRepo = useService<IGetCurrentCashRegisterBalanceRepo>(GetCurrentCashRegisterBalanceRepoType);

  return useQuery(
    ['cash-registers', 'current', 'balance'],
    async () => {
      const result = await getCurrentCashRegisterBalanceRepo.execute();

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    options,
  );
};
